import { BaseModal, ModalOptions, ModalResultType } from "../../../../../../core/modal";
import { Template } from "../../../../../../core/template";
import { FortumApp } from "../../../../../fortumApp";
import { ViewDataBindEvents, DataPropertyChangedEventArgs } from "../../../../../../core/view/data-bind";
import { ClientAction } from "../../../../../synchronizer";
import { OrderDetailViewData } from "../../detail";


export default class AddOrderItemModalView extends BaseModal
{
    public template = Template.lazy('/app/views/decontamination/order/modals/add-item/index.html');
    public data: AddOrderItemModalViewData;
    public app: FortumApp;
    
    private invalidCountErrorMessage: HTMLElement;
    private invalidNameErrorMessage: HTMLElement;

    private cancelButton: HTMLButtonElement;
    private saveButton: HTMLButtonElement;
    private confirmation: HTMLElement;
    private footer: HTMLElement;

    private titleField: HTMLInputElement;
    private countField: HTMLInputElement;

    constructor(data?: AddOrderItemModalViewData)
    {
        super(data);
    }

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('decontamination.Order', 'Add item')
        }
    }

    public beforeRender(): PromiseLike<void>
    {
        this.on(ViewDataBindEvents.DATA_CHANGED, this.onDataChanged);
        return super.beforeRender().then(() =>
        {
            this.data.item_count = 1;
        });
    }
    
    private onDataChanged = (sender, args: DataPropertyChangedEventArgs) =>
    {
        if (args.propertyName == 'item_title' || args.propertyName == 'item_count')
        {
            this.updateErrorMessages(false, args.propertyName);
        }
    };

    public afterRender()
    {
        return super.afterRender().then(() =>
        {
            this.updateErrorMessages(true);
        });
    }

    private onCancelButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(sender, false); 
        this.close(ModalResultType.CANCEL);
    }

    private get toastText()
    {
        return this.app.pgettext('decontamination.OrderItem', 'Successfully added an item!')
    }

    private onSaveButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.confirmation.style.display = 'block';
        this.footer.style.display = 'none';
    }

    private onCancelSaveButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.confirmation.style.display = 'none';
        this.footer.style.display = 'flex';
    }

    private updateErrorMessages(isFirstRun: boolean, sender = null)
    {
        let titleValid = this.data.item_title.length > 0;
        let countValid = this.data.item_count > 0;

        let titleValidSoft = titleValid || isFirstRun;
        let countValidSoft = countValid || isFirstRun;

        this.titleField.classList[titleValidSoft ? 'remove' : 'add']('invalid');
        this.countField.classList[countValidSoft ? 'remove' : 'add']('invalid');

        this.invalidNameErrorMessage.style.display = titleValid || isFirstRun ? 'none' : 'block';
        this.invalidCountErrorMessage.style.display = countValid || isFirstRun ? 'none' : 'block';

        this.saveButton.disabled = (titleValid && countValid) ? false : true;
    }

    private onConfirmSaveButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(this.saveButton, false); 
        this.helpers.setButtonEnabled(this.cancelButton, false); 

        this.app.db.DeconOrderItem.add({
            order_id: this.data.order.id,
            name: this.data.item_title,
            count: this.data.item_count,
            state: 'new',
            is_offline: 1,
        }).then((pk) => {
            return this.app.synchronizer.createMessageAndPull({
                action: ClientAction.DECONTAMINATION.ADD_ORDER_ITEM,
                data: {
                    order_id: this.data.order.id,
                    title: this.data.item_title,
                    count: this.data.item_count,      
                }
            });
        }).then(() =>
        {
            this.close(ModalResultType.OK).then(() =>
            {
                this.app.toasts.show(this.toastText);
            })
        });
    }
}

export interface AddOrderItemModalViewData extends OrderDetailViewData, ModalOptions
{
    item_title: string;
    item_count: number;
}